// import React from "react";
import React, { lazy, Suspense } from "react";
import { Grid, Col, Loader, Toggle } from "rsuite";
import "rsuite/dist/styles/rsuite-default-rtl.css";
import ImageNotif from "../assets/image/notif.png";

import { Route, BrowserRouter, Switch } from "react-router-dom";
import { User, _api } from "../Api";
import Pushe from "pushe-webpush";


// import Jobs from "./jobList";
// import Resume from "./resume";
// import profile from "./profile";
// import JobDetail from "./jobDetail";
// import Login from "./Login";
// import AddAds from "./addAds";
// import EditAds from "./editAds";
// import Confirmation from "./confirmation";
// import EditBid from "./editBid";
// import MyProjectList from "./myProjectList";
// import VerifyProject from "./myRequsetedList";
// import BidList from "./myProjectBidList";
// import OfferList from "./offerList";
// import BidLists from "./myProjectBidLists";
// import SendProject from "./sendProject";
// import UserProfile from "./userProfile";
// import LoginWithSms from "./loginWithSms";
// import FinishProject from "./finishProject";
// import FinalAccept from "./finalAccept";
// import About from "./About";
// import PrivacyPolicy from "./privacyPolicy";
// import Help from "./help";
// import Inovation from "./inovation";
// import Connection from "./Connection";
// import Setting from "./settings";
// import Page404 from "./Page404";
// import ActiveEmailResult from "./activeEmailResult";

const Jobs = lazy(() => import("./jobList"));
const Resume = lazy(() => import("./resume"));
const profile = lazy(() => import("./profile"));
const _profile = lazy(() => import("./_profile"));
const JobDetail = lazy(() => import("./jobDetail"));
const Login = lazy(() => import("./Login"));
const AddAds = lazy(() => import("./addAds"));
const EditAds = lazy(() => import("./editAds"));
const Confirmation = lazy(() => import("./confirmation"));
const EditBid = lazy(() => import("./editBid"));
const MyProjectList = lazy(() => import("./myProjectList"));
const VerifyProject = lazy(() => import("./myRequsetedList"));
const BidList = lazy(() => import("./myProjectBidList"));
const OfferList = lazy(() => import("./offerList"));
const BidLists = lazy(() => import("./myProjectBidLists"));
const SendProject = lazy(() => import("./sendProject"));
const UserProfile = lazy(() => import("./userProfile"));
const LoginWithSms = lazy(() => import("./loginWithSms"));
const FinishProject = lazy(() => import("./finishProject"));
const FinalAccept = lazy(() => import("./finalAccept"));
const About = lazy(() => import("./About"));
const PrivacyPolicy = lazy(() => import("./privacyPolicy"));
const Help = lazy(() => import("./help"));
const Inovation = lazy(() => import("./inovation"));
const Connection = lazy(() => import("./Connection"));
const Setting = lazy(() => import("./settings"));
const Page404 = lazy(() => import("./Page404"));
const ActiveEmailResult = lazy(() => import("./activeEmailResult"));
var appId = "2eymrvzmk0y0n30e";
Pushe.init(appId);
Pushe.subscribe({
  showDialog: true,
  icon:
  ImageNotif,
    // "https://files.pushe.co/prompt-icons/2021/04/20210407-a84be8312e5b477db8f8ab099619211a.png",
  title: "دریافت اطلاع رسانی ها",
  content:
    "اگر می‌خواهید اطلاع رسانی های سایت را دریافت کنید بر روی دکمه تایید کلیک کنید.",
  position: "top-center",
  direction: "rtl",
  acceptText: "تایید دریافت اطلاع رسانی ها",
  rejectText: "خیر",
  promptTheme: "pushe-prompt-theme2",
  mobilePosition: "top",
  dialogRetryRate: 0,
});

const loadingModule = () => (
  <div class="loadingMainPage">
    <img src="/icon-256x256.png" alt="" />
    <h3 class="loading">سایت در حال بارگزاری است لطفا منتظر بمانید</h3>
  </div>
);

class FullWidthTabs extends React.Component {
    constructor(props) {
        super(props);
        this.searchRef = React.createRef();
        this.state = {
            value: 0,
            loading: true,
            // darkMode: false,
        };
        // this.changeMode = this.changeMode.bind(this);
    }

  componentDidMount() {
    this.PusheNotification();
    this.setState({ loading: false });
    const key = localStorage.getItem("key");

    if (key) {
      this.setState({ key: key });
      _api.setAuthToken(key);
    } else {
      _api.setAuthToken();
    }
  }
  PusheNotification = async () => {
    const PusheId = await Pushe.getDeviceId();
    if (PusheId) {
      await User.addNotifToken({ token: PusheId });
    }
  };

  render() {
    const exclueUrl = window.location.pathname.startsWith("/_");
    return (
      <>
        {this.state.loading ? (
          <Loader size="lg" content="Large" />
        ) : (
          <BrowserRouter>
            {/*<div className={"dark-mode"}>*/}
                {/*<Toggle*/}
                    {/*size="lg"*/}
                    {/*checkedChildren="🌘"*/}
                    {/*unCheckedChildren="☀"*/}
                    {/*value={this.state.darkMode}*/}
                    {/*onChange={this.changeMode}*/}
                    {/*checked={this.state.darkMode}*/}
                {/*/>*/}
            {/*</div>*/}
            <Grid fluid>
              <Col md={24} xs={24} sm={24} style={{ padding: 0, margin: 0 }}>
                <Suspense fallback={loadingModule}>
                  <Switch>
                    <Route path={`/`} component={Resume} exact={true} />
                    <Route path={`/experts`} component={Resume} exact={true} />
                    <Route path={`/experts/:company`} component={Resume} exact={true} />
                    <Route
                      path={`/a/:hid`}
                      component={JobDetail}
                      exact={true}
                    />
                    <Route path={`/me`} component={profile} exact={true} />
                    <Route path={`/universityform`} component={_profile} exact={true} />
                    <Route
                      path={`/addAdvertise`}
                      component={AddAds}
                      exact={true}
                    />
                    <Route
                      path={`/editAdvertise/:id`}
                      component={EditAds}
                      exact={true}
                    />
                    <Route path={`/jobs`} component={Jobs} exact={true} />
                    <Route path={`/login`} component={Login} exact={true} />
                    <Route
                      path={`/Confirmation/:id`}
                      component={Confirmation}
                      exact={true}
                    />
                    <Route
                      path={`/EditBid/:id`}
                      component={EditBid}
                      exact={true}
                    />
                    <Route
                      path={`/p/:pass`}
                      component={LoginWithSms}
                      exact={true}
                    />
                    <Route
                      path={`/finish/:id`}
                      component={FinishProject}
                      exact={true}
                    />
                    <Route
                      path={`/FinalAccept/:id`}
                      component={FinalAccept}
                      exact={true}
                    />
                    <Route
                      path={`/sendProject`}
                      component={SendProject}
                      exact={true}
                    />
                    <Route
                      path={`/myRequsetedList`}
                      component={VerifyProject}
                      exact
                    />
                    <Route
                      path={`/myRequsetedList/:id`}
                      component={VerifyProject}
                      exact
                    />

                    <Route path={`/BidList/:id`} component={BidList} />
                    <Route path={`/OfferList/:id`} component={OfferList} />
                    <Route path={`/BidLists`} component={BidLists} exact />
                    <Route path={`/BidLists/:id`} component={BidLists} exact />
                    <Route
                      path={`/myProjectList`}
                      component={MyProjectList}
                      exact={true}
                    />
                    <Route
                      path={`/profile/:hid`}
                      component={UserProfile}
                      exact={true}
                    />
                    <Route path={`/setting`} component={Setting} exact={true} />
                    <Route path={`/about`} component={About} exact={true} />
                    <Route
                      path={`/contact`}
                      component={Connection}
                      exact={true}
                    />
                    <Route
                      path={`/privacyPolicy`}
                      component={PrivacyPolicy}
                      exact={true}
                    />
                    <Route
                      path={`/activemail/:code`}
                      component={ActiveEmailResult}
                      exact={true}
                    />
                    <Route path={`/help`} component={Help} exact={true} />
                    <Route
                      path={`/inovation`}
                      component={Inovation}
                      exact={true}
                    />
                    {!exclueUrl && <Route component={Page404} />}
                  </Switch>
                </Suspense>
              </Col>
            </Grid>
          </BrowserRouter>
        )}
      </>
    );
  }
}

export default FullWidthTabs;
